export const typography = {
  h1: {
    size: 24,
    lineHeight: 32,
    weight: 600,
  },
  h2: {
    size: 20,
    lineHeight: 28,
    weight: 600,
  },
  h3: {
    size: 16,
    lineHeight: 24,
    weight: 600,
  },
  h4: {
    size: 14,
    lineHeight: 20,
    weight: 600,
  },
  body1: {
    size: 14,
    lineHeight: 20,
    weight: 400,
  },
  body2: {
    size: 13,
    lineHeight: 18,
    weight: 400,
  },
  caption1: {
    size: 12,
    lineHeight: 16,
    weight: 400,
  },
  caption2: {
    size: 11,
    lineHeight: 14,
    weight: 400,
  },
  smallText1: {
    size: 12,
    lineHeight: 18,
    style: 'normal',
    weight: 500,
  },
} as const;

export const landingTypography = {
  h1: {
    size: 90,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h2: {
    size: 64,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h3: {
    size: 45,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h4: {
    size: 32,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h5: {
    size: 20,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h6: {
    size: 16,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h7: {
    size: 14,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  h8: {
    size: 12,
    lineHeight: '130%',
    weight: 600,
    letterSpacing: '-0.03em',
  },
  caption1: {
    size: 16,
    lineHeight: '120%',
    weight: 600,
    letterSpacing: '0.3em',
    textTransform: 'uppercase',
  },
  caption2: {
    size: 14,
    lineHeight: '120%',
    weight: 600,
    letterSpacing: '0.3em',
    textTransform: 'uppercase',
  },
} as const;

export const RevenueMarketFontFamily =
  '"Pretendard Variable", Pretendard, "Malgun gothic", "맑은 고딕", -apple-system, BlinkMacSystemFont, helvetica, "apple SD Gothic Neo", sans-serif';
